import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import ManagedAccountModelUpdateRequestNotes from './ManagedAccountModelUpdateRequestNotes';

const DetailContainer = ({
  relationshipLink,
  notesPortalRef,
}) => {
  const {
    isInitializing,
    loadingError,
    collection,
    setCollection,
    refreshCollection,
  } = useLink(relationshipLink);

  useLayoutEffect(() => {
    // If we have no notes or if the last item of the collection has been created,
    // add a new note to the collection to allow adding another
    if ((!isInitializing && collection?.resources()?.length() === 0)
        || collection?.resources()?.last()?.id() > 0) {
      setCollection(collection.create({ addToCollection: true }));
    }
  }, [isInitializing, collection?.resources()?.last()?.id()]);

  return (
    <>
      <DataContainer
        component={ManagedAccountModelUpdateRequestNotes}
        loading={isInitializing}
        loadingError={loadingError}
        componentProps={{
          collection,
          refreshCollection,
          notesPortalRef,
        }}
      />
    </>
  );
};

DetailContainer.propTypes = {
  relationshipLink: PropTypes.object.isRequired,
  notesPortalRef: PropTypes.object.isRequired,
};

export default DetailContainer;
